<template>
  <div>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-8">
        <div class="card border border-warning">
          <div class="card-header bg-transparent border-warning"><h5 class="my-0 text-warning"><i class="mdi mdi-alert mr-3"></i>Aviso </h5></div>
          <div class="card-body pt-0">
            <p class="card-text font-size-14">
              A {{entidade.ent_nome}}, informa que a partir do dia 01/09/2023, as notas fiscais de serviços emitidas pelos Microempreendedores Individuais (MEI)
              deverão ser <b>obrigatoriamente emitidas</b> pelo <a target="_blank" href="https://www.gov.br/nfse">Portal Nacional da Nota Fiscal de Serviços eletrônica</a> (<a target="_blank" href="https://www.gov.br/nfse">https://www.gov.br/nfse</a>).
              <br>
              <br>
              A obrigatoriedade foi determinada pela Resolução CGSN 169/2022 alterada pela Resolução CGSN 171/2022, que trouxe novas diretrizes
              de padronização e simplificação para a emissão das notas fiscais pelos MEI. Como consequência, a partir desta data (01/09/2023),
              os Microempreendedores <b>não poderão mais emitir a NFS-e no sistema disponibilizado pelo município</b>.
              <br>
              <br>
              O atual sistema municipal continuará disponível, a partir do dia 01/09/2023, apenas para consultas e eventuais cancelamentos de notas fiscais emitidas até o dia 31/08/2023.
              <br>
              <br>
              Está disponível ao contribuinte o link que contém e-book e vídeos do passo a passo de como se cadastrar e emitir nota fiscal pelo Portal da Nota Fiscal:
              <br>
              <a target="_blank" href="https://www.gov.br/nfse/pt-br/mei/links-com-passo-a-passo">https://www.gov.br/nfse/pt-br/mei/links-com-passo-a-passo</a>
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "aviso-mei",
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
  }
};
</script>
